var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRegister = function SvgIconRegister(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_register_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "m15 7.5-1.175-1.183-5.492 5.492-2.158-2.15L5 10.833l3.333 3.333zm.833-5H12.35A2.51 2.51 0 0 0 10 .833c-1.083 0-2 .7-2.35 1.667H4.167a1.5 1.5 0 0 0-.334.034 1.67 1.67 0 0 0-1.2.991 1.6 1.6 0 0 0-.133.642v11.667c0 .224.05.45.133.65.084.2.209.374.359.533.225.225.516.392.841.458.109.017.217.025.334.025h11.666c.917 0 1.667-.75 1.667-1.666V4.167c0-.917-.75-1.667-1.667-1.667M10 2.292a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625m5.833 13.542H4.167V4.167h11.666z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_register_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconRegister;